import {createApi} from "@reduxjs/toolkit/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {transformResponse} from "@commons/utils/APIParams";
import {SettoreContrattiRecord} from "@commons/mapping/SettoriCCNL";
import {EntePrevidenzialeRecord} from "@commons/mapping/EntePrevidenzialeRecord";
import {config} from "@commons/config.instance";

export const tabelleDiSistemaApi = createApi({
    reducerPath: 'tabelleDiSistemaApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({

        //CCNL https://fpnet2.ericed.it/FPNet2021/tabella/ccnl?auth_token=d2b11b3fd42e99dbcee8e79f86463fd8&nowId=1672157517419&nowId=1672157517400
        getCCNL: builder.query<SettoreContrattiRecord[], void>({
            query: () => {
                return `/tabella/ccnl`;
            },
            transformResponse
        }),

        //ENTE https://fpnet2.ericed.it/FPNet2021/ente/previdenziale?auth_token=c4ea036ea171471e13d980ccec316499&nowId=1672233505613&nowId=1672233505597
        getEntePrevidenziale: builder.query<EntePrevidenzialeRecord[], void>({
            query: () => {
                return `/ente/previdenziale`;
            },
            transformResponse
        }),

        //GESTIONE https://fpnet2.ericed.it/FPNet2021/ente/inail/gestione?auth_token=c4ea036ea171471e13d980ccec316499&nowId=1672233505613&nowId=1672233505597
        getEnteAssicurativo: builder.query<{ descrizione: string, idGestione: number }[], void>({
            query: () => {
                return `/ente/inail/gestione`;
            },
            transformResponse
        }),

        //SEDE https://fpnet2.ericed.it/FPNet2021/ente/inail/sede?auth_token=c4ea036ea171471e13d980ccec316499&nowId=1672233505613&nowId=1672233505597
        getSedeInail: builder.query<{ descrizione: string, idSede: number }[], void>({
            query: () => {
                return `/ente/inail/sede`;
            },
            transformResponse
        }),
    }),
})
export const {
    useGetCCNLQuery,
    useGetEntePrevidenzialeQuery,
    useGetEnteAssicurativoQuery,
    useGetSedeInailQuery,
} = tabelleDiSistemaApi;
